export const experiences = [
    {

      "title": "Software Engineer Intern in Test",
      "organization": "Foresters Financial",
      "location": "Toronto, Canada", 
      "period": "May 2025 - Aug. 2025 ",
      "responsibilities": [
        "Led the development of Selenium-based automation testing projects using Java, aligning with organization QA standards and ensuring reliable software performance.",
        "Engineered an AI-powered Azure bot using TypeScript that integrates with Microsoft Teams meetings; implemented voice-activated queries to SharePoint to streamline information retrieval and enhance meeting productivity."
      ]
    },
    {
      "title": "Software Engineer Intern",
      "organization": "ElleSante",
      "location": "Toronto, Canada", 
      "period": "Jan. 2025 - May. 2025",
      "responsibilities": [
        "Developed a user-friendly mobile application interface using Flutter, ensuring smooth navigation and an intuitive user experience.",
        "Developed an online interface using React and Mantine UI, ensuring a smooth and responsive user experience through optimized component structures and efficient state management."
      ]
    },
    {
      "title": "Web Developer",
      "organization": "African Student Association",
      "location": "Toronto, Canada",
      "period": "Oct. 2024 -Jan. 2025",
      "responsibilities": [
        "Collaborated with a cross-functional team using Figma to design and develop front-end UI/UX components for a website using a user-centered design approach, focusing on creating a visually appealing and functional interface.",
        "Built the back end using Express, MongoDB, and integrated AWS S3 buckets for an efficient and scalable storage solution.",
        "Developed the front end using React and Tailwind, ensuring a modern but highly adapted user interface that successfully integrated African cultural design elements with contemporary interface design standards."
      ]
    },

]